
/**
 * 短信模版相关
 * @author tylerzzheng
 */
import { CommonList, IAddSmsTemplate, IRuleFilter, ISmsTemplate, Pagination, IRule, IEditSmsTemplate } from '@types'
import { requestApi } from '@library'

// 获取规则列表
export function getRuleListNoSession (ruleFilter: IRuleFilter & {belongModule: number}) {
  return requestApi<CommonList<IRule>>('GetRuleList', ruleFilter)
}

// 获取短信模版列表
export function getSmsTemplateList (pagination: Pagination) {
  return requestApi<CommonList<ISmsTemplate>>('GetSmsTemplateList', pagination)
}

// 添加短信模版
export function addSmsTemplate (addSmsTemplate: IAddSmsTemplate) {
  return requestApi<{}>('AddSmsTemplate', addSmsTemplate)
}

// 修改短信模版
export function editSmsTemplate (editSmsTemplate: IEditSmsTemplate) {
  return requestApi<{}>('UpdateSmsTemplate', editSmsTemplate)
}

// 修改短信模版
export function deleteSmsTemplate (deletedSmsTemplate: { templateId: number }) {
  return requestApi<{}>('DeleteSmsTemplate', deletedSmsTemplate)
}
